import {Component, EventEmitter, Input, Output, TemplateRef, ViewChild} from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { Table, TableLazyLoadEvent, TableModule} from 'primeng/table';
import { CommonModule } from '@angular/common';
import { TableHeaderComponent } from './table-header/table-header.component';
import { TableCaptionComponent } from './table-caption/table-caption.component';
import { TableBodyComponent } from './table-body/table-body.component';
import { IButtonColumn, ICustomTable, IDataColumn, IDropdownSelect } from '../../../../shared/interfaces/custom-work/customTable';
import { MultiSelectModule } from 'primeng/multiselect';
import { FormsModule } from '@angular/forms';
import { CustomTableTypeChecker } from '../../../../shared/classes/custom-table-type-checker';
import { TableFooterComponent } from './table-footer/table-footer.component';
import { TranslateModule } from '@ngx-translate/core';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import {SvgLoaderComponent} from "../../../svg-loader/svg-loader.component";

@Component({
  selector: 'custom-table',
  standalone: true,
  imports: [TableModule, ButtonModule, CommonModule, MultiSelectModule, FormsModule, TranslateModule, InputTextModule,
    TableHeaderComponent, TableCaptionComponent, TableBodyComponent, TableFooterComponent, IconFieldModule, InputIconModule, SvgLoaderComponent
  ],
  templateUrl: './custom-table.component.html',
  styleUrl: './custom-table.component.scss'
})
export class CustomTableComponent<T = any> {

  @Input() config !: ICustomTable<T>;
  @Input() rowExpansionTemplate?: TemplateRef<any>;
  isLoading: boolean = true;
  private _selectedColumns !: (IDataColumn | IButtonColumn<T>)[];

  @Output() emitterLazyLoad = new EventEmitter<TableLazyLoadEvent>();
  private _page: number = 0;
  private _totalRecords: number  = 0;

  private _multiSelectOptions !: (IDataColumn | IButtonColumn<T>)[];
  private _selectedMultiSelectOptions !: (IDataColumn | IButtonColumn<T>)[];

  expandedRowKeys: {} = {};

  @ViewChild(TableCaptionComponent) tableCaptionComponent !: TableCaptionComponent;
  constructor() {
  }

  get settings() {
    return this.config?.settings;
  }

  get rows() {
    return this.config?.settings?.table?.rows ?? 5;
  }

  get scrollable(): boolean {
    return this.config?.settings?.table?.scrollable ?? false;
  }

  get tableStyle(): { [key: string]: any } |  null | undefined {
    return this.config?.settings?.table?.tableStyle;
  }

  get scrollHeight(): string | undefined {
    return this.config?.settings?.table?.scrollHeight ;
  }

  get data() {
    return this.config?.data ?? [];
  }

  set data(data: any[]) {
    this.isLoading = false;
    this.config.data = data;
    this.setupColumns();
  }

  get columns() {
    return this.config?.columns;
  }

  get footer() {
    return this.config?.footer;
  }

  get header() {
    return this.config?.header;
  }

  get dataKey(){
    return this.config?.dataKey ?? 'id';
  }

  get showColumnToggle() {
    return this.settings?.columnToggle?.showColumnToggle ?? false;
  }

  get maxSelectedLabels() {
    return this.settings?.columnToggle.maxSelectedLabels ?? 5;
  }

  get paginator(): boolean {
    return this.settings?.table?.paginator ?? true;
  }

  get selectedColumns(): (IDataColumn | IButtonColumn<T>)[] {
    return this._selectedColumns;
  }

  get selectedMultiSelectOptions(): (IDataColumn | IButtonColumn<T>)[] {
    return this._selectedMultiSelectOptions;
  }

  set selectedMultiSelectOptions(val: (IDataColumn | IButtonColumn<T>)[]) {
    //restore original order
    this._selectedMultiSelectOptions = this._multiSelectOptions.filter((col) => val.includes(col));
    this._selectedColumns = this.columns.filter((col) => val.includes(col) || !CustomTableTypeChecker.isDataColumn(col));
  }

  get multiSelectOptions(): (IDataColumn | IButtonColumn<T>)[] {
    return this._multiSelectOptions
  }

  get lazy() {
    return this.settings?.table?.lazy ?? false;
  }

  get totalRecords(): number {
    return this._totalRecords;
  }

  set totalRecords(value: number) {
    this._totalRecords = value;
  }


  setupColumns() {
    this._multiSelectOptions = this.columns.filter((col) => CustomTableTypeChecker.isDataColumn(col));
    this._selectedMultiSelectOptions = this._multiSelectOptions.filter((col) => !col.optional);;
    this._selectedColumns = this.columns.filter((col) => !col.optional);
  }

  setHeaderDropdownSelect(data: IDropdownSelect) {
    this.tableCaptionComponent.setDropdownSelect(data);
  }


  lazyloadRecords(event: TableLazyLoadEvent) {
      this.emitterLazyLoad.emit(event);
  }

  @ViewChild('dt2') dt2 !: Table;

  onSearchInput(event: string) {
    this.dt2.filterGlobal(event, 'contains');
  }
}
